import React from "react";
import SocialSet from "../../libs/SocialSet";

import "./Socials.scss";

const Socials = (props) => {
  const hostURL = window.location.host;
  const pathURL = window.location.pathname;

  return (
    <div className="Socials">
      <div className="Socials__text">Share</div>
      <a
        rel="noreferrer"
        target="_blank"
        href={`mailto:?subject=${encodeURI(
          SocialSet.emailSubject
        )}&body=${encodeURI(SocialSet.emailBody)} https://${hostURL}${pathURL}`}
        className="Socials__icon Socials__icon--1"
      ></a>
      <a
        rel="noreferrer"
        href={`https://www.linkedin.com/shareArticle?mini=true&url=https://${hostURL}${pathURL}`}
        className="Socials__icon Socials__icon--4"
        target="_blank"
      ></a>
      <a
        rel="noreferrer"
        href={`https://twitter.com/intent/tweet?url=https://${hostURL}${pathURL}&text=${encodeURI(
          SocialSet.twitter
        )}`}
        className="Socials__icon Socials__icon--3"
        target="_blank"
      ></a>
      <a
        rel="noreferrer"
        href={`https://www.facebook.com/sharer/sharer.php?u=https://${hostURL}${pathURL}`}
        target="_blank"
        className="Socials__icon Socials__icon--2"
      ></a>
    </div>
  );
};

export default Socials;
